import React, { createRef } from 'react'
import '../style.scss'
import { Link } from 'gatsby'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.nav = createRef()
    this.linkPairs = ['/about', '/', '/list']
    this.links = []
    this.links[0] = createRef()
    this.links[1] = createRef()
    this.links[2] = createRef()
    this.landing = createRef()
  }
  componentDidMount() {
    setTimeout(() => {
      this.nav.current.classList.remove('header-landing')
    }, 1000)
    setTimeout(() => {
      const loc = '/' + this.props.location.split('/')[1]
      this.links[
        this.linkPairs.indexOf(loc) > -1 ? this.linkPairs.indexOf(loc) : 1
      ].current.classList.add('active')
      this.landing.current.classList.add('show')
    }, 2000)
    this.landing.current.addEventListener('click', (e) => {
      e.target.classList.add('out')
    })
    if (this.props.location !== '/') {
      this.landing.current.classList.add('out')
    }
  }
  componentDidUpdate() {
    if (this.props.location !== '/') {
      this.landing.current.classList.add('out')
    }
    const loc = '/' + this.props.location.split('/')[1]
    this.links.forEach((l, i) => {
      if (this.linkPairs.indexOf(loc) === i) {
        l.current.classList.add('active')
      } else {
        l.current.classList.remove('active')
      }
    })
    if (this.linkPairs.indexOf(loc) === -1) {
      this.links[1].current.classList.add('active')
      this.links[0].current.classList.remove('active')
      this.links[2].current.classList.remove('active')
    }
  }
  render() {
    return (
      <>
        <nav ref={this.nav} className="header-landing">
          <Link className="link" ref={this.links[0]} to="/about">
            <div className="button">
              <div>ABOUT</div>
              <div>
                {Array.from('ABOUT').map((w, i) => (
                  <span key={i} style={{ '--i': i }}>
                    -
                  </span>
                ))}
              </div>
            </div>
          </Link>
          <Link className="link" ref={this.links[1]} to="/">
            <div className="button">
              <div>A-THESISSS-SHOW</div>
              <div>
                {Array.from('A-THESISSS-SHOW').map((w, i) => (
                  <span key={i} style={{ '--i': i }}>
                    -
                  </span>
                ))}
              </div>
            </div>
          </Link>
          <Link className="link" ref={this.links[2]} to="/list">
            <div className="button">
              <div>INDEX</div>
              <div>
                {Array.from('INDEX').map((w, i) => (
                  <span key={i} style={{ '--i': i }}>
                    -
                  </span>
                ))}
              </div>
            </div>
          </Link>
        </nav>
        <div className="landing-page disable-page-scroll" ref={this.landing}>
          <div className="text">
            <p>
              A-THESISSS-SHOW: 20-ARTISTS-CURATED-BY-20-ARTISTS is an online art
              exhibition connecting a global roster of artists whose final
              undergraduate exhibitions were compromised by COVID-19. Curated
              like a game of telephone, each student artist elected another
              student artist to be included in the show. This pattern continued
              from country to country, medium to medium, until a twenty-person
              line-up was complete. The exhibition explores the notion of
              digital connectivity and community during an era of interrupted
              physical correspondence.
            </p>
            <p>
              A-THESISSS-SHOW is a ssspecial project produced and led by
              SOMETHING-SPECIAL-STUDIOS. The concept for an online student
              exhibition was brought to SSS by CHLOE-WALECKI, as a proposal for
              her final internship project with the studio.
            </p>
          </div>
        </div>
      </>
    )
  }
}

export default Header
